import { createSlice } from "@reduxjs/toolkit";
import { FAQJson } from "../../../domain/faq/FAQ";
import { ActionType, getFAQListAction, updateFAQAction, deleteFAQAction } from "./action";

export type FAQState = Readonly<{
    faqList: FAQJson[] | null,
    processing: number
}>;

const faqInitialState: FAQState = {
    faqList: null,
    processing: 0
};

const slice = createSlice({
    name: ActionType.base,
    initialState: faqInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(
                getFAQListAction.pending,
                (state) => {
                    state.faqList = [];
                    state.processing += 1;
                }
            )
            .addCase(
                getFAQListAction.fulfilled,
                (state, action) => {
                    const { payload } = action;
                    const { faqList } = payload;
                    state.faqList = faqList;
                    state.processing -= 1;
                }
            )
            .addCase(
                getFAQListAction.rejected,
                (state) => {
                    state.processing -= 1;
                }
            )
            .addCase(
                updateFAQAction.pending,
                (state) => {
                    state.processing += 1;
                }
            )
            .addCase(
                updateFAQAction.fulfilled,
                (state) => {
                    state.processing -= 1;
                }
            )
            .addCase(
                updateFAQAction.rejected,
                (state) => {
                    state.processing -= 1;
                }
            ).addCase(
                deleteFAQAction.pending,
                (state) => {
                    state.processing += 1;
                }
            )
            .addCase(
                deleteFAQAction.fulfilled,
                (state, action) => {
                    state.processing -= 1;
                    if (!state.faqList) return;
                    const { deletedFAQId } = action.payload;
                    state.faqList = state.faqList.filter(faq => faq.id !== deletedFAQId);
                }
            )
            .addCase(
                deleteFAQAction.rejected,
                (state) => {
                    state.processing -= 1;
                }
            );
    }
});

export const faqReducer = slice.reducer; 
